import { render, staticRenderFns } from "./LandingLanguageButton.vue?vue&type=template&id=cbbd3584&scoped=true"
import script from "./LandingLanguageButton.vue?vue&type=script&lang=js"
export * from "./LandingLanguageButton.vue?vue&type=script&lang=js"
import style0 from "./LandingLanguageButton.vue?vue&type=style&index=0&id=cbbd3584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbd3584",
  null
  
)

export default component.exports